import React from 'react'
import { connect } from 'react-redux'
import { getActivityImage, getActivityName } from 'store/entities/activity/selectors'
import fireCrossBrowserResize from 'helpers/fireCrossBrowserResize'

import './styles.scss'

const mapStateToProps = state => ({
  image: getActivityImage(state),
  name: getActivityName(state),
})

const UserActivityControlPanelCarouselSlideImage = ({ image, name }) => (
  <div className="carousel-slide-image">
    <img src={image} alt={name} onLoad={() => fireCrossBrowserResize()} />
  </div>
)

UserActivityControlPanelCarouselSlideImage.displayName = 'UserActivityControlPanelCarouselSlideImage'

const UserActivityControlPanelCarouselSlideImageContainer = connect(mapStateToProps)(
  UserActivityControlPanelCarouselSlideImage
)

UserActivityControlPanelCarouselSlideImageContainer.displayName = 'UserActivityControlPanelCarouselSlideImageContainer'

export default UserActivityControlPanelCarouselSlideImageContainer
